// Types
import { TDealTypeKey } from "@/DataPages/types/salesOperations/salesLog/utils";

const TAB_NAMES = {
	NEW_VEHICLES: "New Vehicles",
	PRE_OWNED_VEHICLES: "Pre-Owned Vehicles",
	WHOLESALE: "Wholesale",
	FI: "F&I",
	COMBINED: "Combined",
} as const;

const BACKOUT = "BACKOUT";

const DEAL_TYPE_KEYS = {
	L: "L",
	R: "R",
	W: "W",
	T: "T",
	F: "F",
} as const;

const DEAL_TYPE_MAP: Record<TDealTypeKey, string> = {
	[DEAL_TYPE_KEYS.L]: "Lease",
	[DEAL_TYPE_KEYS.R]: "Retail",
	[DEAL_TYPE_KEYS.W]: "Wholesale",
	[DEAL_TYPE_KEYS.T]: "Dealer Trade",
	[DEAL_TYPE_KEYS.F]: "Fleet",
};

const DEFAULT_NEW_VEHICLES = {
	disabled: [DEAL_TYPE_KEYS.W],
	unchecked: [DEAL_TYPE_KEYS.W],
};

const DEFAULT_INCLUDED_STATES_BY_TABS: Record<
	(typeof TAB_NAMES)[keyof typeof TAB_NAMES] | "default",
	{ disabled: TDealTypeKey[]; unchecked: TDealTypeKey[] }
> = {
	[TAB_NAMES.PRE_OWNED_VEHICLES]: {
		disabled: [DEAL_TYPE_KEYS.F, DEAL_TYPE_KEYS.L],
		unchecked: [DEAL_TYPE_KEYS.F, DEAL_TYPE_KEYS.L, DEAL_TYPE_KEYS.W],
	},
	[TAB_NAMES.WHOLESALE]: {
		disabled: (Object.keys(DEAL_TYPE_MAP) as TDealTypeKey[]).filter(
			(key: TDealTypeKey) => ![DEAL_TYPE_KEYS.W, DEAL_TYPE_KEYS.F].includes(key as typeof DEAL_TYPE_KEYS.W | typeof DEAL_TYPE_KEYS.F)
		),
		unchecked: (Object.keys(DEAL_TYPE_MAP) as TDealTypeKey[]).filter((key) => key !== DEAL_TYPE_KEYS.W),
	},
	[TAB_NAMES.FI]: {
		disabled: [DEAL_TYPE_KEYS.W],
		unchecked: [DEAL_TYPE_KEYS.W],
	},
	[TAB_NAMES.COMBINED]: {
		disabled: [],
		unchecked: [],
	},
	/* For locations with only one brand (Chevrolet) */
	[TAB_NAMES.NEW_VEHICLES]: DEFAULT_NEW_VEHICLES,
	/* For locations with multiple brands (Mitsubishi, Chevrolet) */
	["default"]: DEFAULT_NEW_VEHICLES,
};

export { TAB_NAMES, BACKOUT, DEAL_TYPE_MAP, DEFAULT_INCLUDED_STATES_BY_TABS, DEAL_TYPE_KEYS };
